import { PText } from "@porsche-design-system/components-react";
import { AuthContext } from "MainApp/assets/utils/context/AuthContext";
import { useContext } from "react";

const CText = ({ children, size, color, weight, align, theme, slot, style }) => {
  const { isTuk } = useContext(AuthContext);

  return (
    <PText
      size={size}
      color={!color ? isTuk ? "dark" : "light" : color }
      weight={weight}
      align={align}
      theme={theme}
      slot={slot}
      style={style}
    >
      {children}
    </PText>
  );
};

export default CText;
